exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "[data-module=Resources] ul.resources-container{margin-top:20px;display:flex;flex-direction:row;flex-wrap:wrap;justify-content:space-between}[data-module=Resources] ul.resources-container li.resource-item{display:inline-block;width:48%;max-width:48%}[data-module=Resources] ul.resources-container li.resource-item img{width:100%}[data-module=Resources] ul.resources-container li.resource-item .title{font-size:24px;font-weight:400;color:#25853b;margin:16px 0 5px;padding:0}[data-module=Resources] ul.resources-container li.resource-item .description{margin:0;padding:0;font-size:20px;color:#000;line-height:1.2em}[data-module=Resources] ul.resources-container li.resource-item .button{padding:12px 18px;margin:18px 0;text-decoration:none}[data-module=Resources] ul.resources-container li.resource-item .button:hover{text-decoration:none}[data-module=Resources] ul.resources-container li.resource-item .button .title{color:#fff;text-decoration:none;font-size:18px;font-weight:600}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/app/resources/styles.scss
// module id = 653
// module chunks = 0